import React from "react";
import EmployeeNavbar from "../Layout/EmployeeNavbar";
import PlacementAdminPage from "../placement/PlacementAdminPage";

export default function EmployeePlacementPage() {
  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <EmployeeNavbar />
      <PlacementAdminPage />
    </div>
  );
}
